import { render, staticRenderFns } from "./hospitalservice.vue?vue&type=template&id=64282853&scoped=true"
import script from "./hospitalservice.vue?vue&type=script&lang=js"
export * from "./hospitalservice.vue?vue&type=script&lang=js"
import style0 from "./hospitalservice.vue?vue&type=style&index=0&id=64282853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64282853",
  null
  
)

export default component.exports